


















































import Vue from 'vue'
import Component from 'vue-class-component'
import Card from '@/components/Card.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import { EZuntaInvoiceType } from '@zunta/configurations'
import { ChainModule } from '@/store/modules/chain.module'
import { getModule } from 'vuex-module-decorators'
import { BillingModule } from '@/store/modules/billing.module'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'

@Component({
  components: {
    LoaderWrapper,
    Card,
    Checkbox
  }
})
export default class CreateBatchModal extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  billingModuleInstance: BillingModule = getModule(BillingModule, this.$store)
  invoiceTypes: EZuntaInvoiceType[] = []
  EZuntaInvoiceType: any = EZuntaInvoiceType
  isLoading: boolean = false

  get batchId () {
    return this.$route.params.batch
  }

  get selectedBatch () {
    return this.$store.state.chain.selectedBatch
  }

  async mounted () {
    try {
      this.isLoading = true
      await this.chainModuleInstance.fetchBillingBatch(+this.batchId)
      this.invoiceTypes = this.selectedBatch.invoiceTypes || []
    } finally {
      this.isLoading = false
    }
  }

  async save () {
    try {
      this.isLoading = true
      await this.billingModuleInstance.updateBatchInvoiceTypes({
        batchId: this.batchId,
        invoiceTypes: this.invoiceTypes
      })

      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        message: 'Settings Saved',
        header: `Update Settings`,
        icon: 'check'
      })
    } finally {
      this.isLoading = false
    }
  }

  isInvoiceTypeChecked (type: EZuntaInvoiceType) {
    return this.invoiceTypes.includes(type)
  }

  toggleInvoiceType (event: any, type: EZuntaInvoiceType) {
    const index = this.invoiceTypes.findIndex((invoiceType: EZuntaInvoiceType) => invoiceType === type)
    if (index === -1) {
      this.invoiceTypes.push(type)
    } else {
      this.invoiceTypes.splice(index, 1)
    }
  }
}
